import { render } from "./affinityListComponent.vue?vue&type=template&id=6518bca1&ts=true"
import script from "./affinityListComponent.vue?vue&type=script&lang=ts"
export * from "./affinityListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__